// extracted by css-extract-rspack-plugin
export default {"Box":"table-cell-module__Box__BGiD5","StyledTableCell":"table-cell-module__StyledTableCell__Kzgvf"};